import axios from 'axios';

import { SourceCamera, SourceConfig } from '../types';

export const verkadaConfig: SourceConfig = {
  label: 'Verkada',
  description: 'Import cameras from Verkada',
  credentialFields: [
    {
      name: 'org_id',
      label: 'Organization ID',
      type: 'text',
      required: true,
    },
    {
      name: 'api_key',
      label: 'API Key',
      type: 'password',
      required: true,
      helpText:
        'Must have Camera fetch and Streaming - Live/historical permissions.',
    },
    {
      name: 'region',
      label: 'Region',
      type: 'select',
      required: false,
      defaultValue: 'api',
      options: [
        { label: 'US (default)', value: 'api' },
        { label: 'EU', value: 'api.eu' },
      ],
    },
  ],
  qualityOptions: [
    { label: 'Low', value: 'low_res' },
    { label: 'High', value: 'high_res' },
  ],
  defaultQuality: 'low_res',

  async fetchCameras(
    credentials: Record<string, string>,
    apiBaseUrl: string
  ): Promise<SourceCamera[]> {
    const allCameras: SourceCamera[] = [];
    let nextPage: string | null = null;
    const MAX_PAGES = 100;
    let pageCount = 0;

    do {
      const body: Record<string, string> = {
        api_key: credentials.api_key,
        region: credentials.region || 'api',
      };
      if (nextPage) {
        body.page_token = nextPage;
      }

      const { data } = await axios.post(
        `${apiBaseUrl}/integrations/verkada/cameras`,
        body
      );
      const cameras = data.cameras ?? [];
      nextPage = data.next_page_token ?? null;

      for (const camera of cameras) {
        allCameras.push({
          id: camera.camera_id,
          name: camera.name ?? '',
          location: camera.site ?? '',
          model: camera.model,
          serial: camera.serial,
          mac: camera.mac,
        });
      }
      pageCount++;
    } while (nextPage && pageCount < MAX_PAGES);

    return allCameras.sort(
      (a, b) =>
        a.location.localeCompare(b.location) || a.name.localeCompare(b.name)
    );
  },

  buildStreamUri(
    camera: SourceCamera,
    credentials: Record<string, string>,
    quality: string,
    apiBaseUrl: string
  ): string {
    const params = new URLSearchParams({
      api_key: credentials.api_key,
      org_id: credentials.org_id,
      camera_id: camera.id,
      quality,
      region: credentials.region || 'api',
    });

    return `${apiBaseUrl}/integrations/verkada/stream?${params}`;
  },

  buildStreamName(camera: SourceCamera, quality: string): string {
    return `${camera.location} - ${camera.name} (${quality})`;
  },
};
